import Vuex from 'vuex'
import getters from './getters'
import { api } from './modules/api'

const store = new Vuex.Store({
  modules: {
    api
  },
  getters
})

export default store
